import platform from "platform";
import { ref } from "vue";
import { debugStep, pwaHomePageUrl } from "../global.js";
let isChrome = false;
let isAndroid = false;

//
let startUrl = "/";

//
let url = new URL(window.location.href);
let params = new URLSearchParams(window.location.search);
let lang = params.get("up_lang");

//
function isMobileDevice() {
  return /Mobi|Android|iPhone/i.test(navigator.userAgent);
}

function pushSubscription(subscription) {
  if (!subscription) throw Error("user unsubscription");
  saveSub(subscription);
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function checkPlatform() {
  let platformInfo = platform.parse(navigator.userAgent);
  if (platformInfo.name != null) {
    if (platformInfo.os.family.includes("Android")) {
      isAndroid = true;
      if (platformInfo.name.includes("Chrome")) {
        isChrome = true;
      }
    }
  } else {
    isAndroid =
      navigator.userAgent.indexOf("Android") > -1 ||
      navigator.userAgent.indexOf("Adr") > -1;
  }
  // alert(navigator.userAgent)
}

//
function openByChrome() {
  // alert(2)
  const uRL = new URL(location.href);

  jumpChrome(`https://${uRL.host}/#/?lpUrl=${btoa(location.href)}`);
}
function jumpChrome(targetUrl) {

  try {
    let href = `intent://${targetUrl.replace(
      /(https|http):\/\//,
      ""
    )}#Intent;scheme=https;action=android.intent.action.VIEW;component=com.android.chrome;package=com.android.chrome;end`;
    // alert(href)
    location.href = href
  } catch (e) {
    alert(e);
  }
}
// function openChromeDownload() {

//         //
//         location.href = 'market://details?id=com.android.chrome';

// }
function openChromeDownloadPage() {
  location.href = "market://details?id=com.android.chrome";
  let timerId = setTimeout(() => {
    if (document.visibilityState === "hidden") {
      return;
    }
    debugStep.value = 13;
    clearTimeout(timerId);
    window.open(
      "https://play.google.com/store/apps/details?id=com.android.chrome",
      "_blank"
    );
  }, 2000);
}

function openPwaHomePage() {
  location.href = `${pwaHomePageUrl}`;
}

function openInstalledPwa() {
  // PWA,manifeststart_url
  // ChromePWA

  try {
    // alert('openInstalledPwa',startUrl)
    window.open(`${startUrl}`, "_blank");

    // 3,document.hiddenopenPwaHomePage
    setTimeout(() => {
      debugStep.value = 5;
      if (document.visibilityState === "hidden") {
        return;
      }

      debugStep.value = 6;
      openPwaHomePage();
    }, 2000);
  } catch (e) {
    debugStep.value = 7;
    openPwaHomePage();
  }
}
function isIPhone() {
  return /iPhone|iPad|iPod/.test(navigator.userAgent);
}
function isInStandaloneMode() {
  // For iOS
  if (window.navigator.standalone) {
    return true;
  }

  // For other platforms
  if (window.matchMedia("(display-mode: standalone)").matches) {
    return true;
  }

  return false;
}
function isInFacebook() {
  var ua = navigator.userAgent;
  // 检查 userAgent 是否包含 Facebook 的特定标识
  if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) {
    return true;
  }
  return false;
}
export {
  openByChrome,
  isInFacebook,
  isInStandaloneMode,
  isIPhone,
  openPwaHomePage,
  openChromeDownloadPage,
  checkPlatform,
  isAndroid,
  isChrome,
  isMobileDevice,
  openInstalledPwa,
};
